import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.wheelOfFortuneCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.wheelOfFortuneCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) => state.wheelOfFortuneCollections.data.wheelOfFortuneCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.wheelOfFortuneCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
